// pages/ArticlePage.jsx
import { useState, useEffect } from "react";
import { getAllArticles } from "../../api/articleApi";
import Header from "../Header";
import GetAdmin from "../../utils/getAdmin";
import Loading from "../loading";
import NotFoundPage from "./404";
import Navigation from "../Navigation";
import AddArticleForm from "../Forms/addArticleForm";
import ArticleTable from "../tables/ArticleTable";

const ArticlePage = () => {
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [editData, setEditData] = useState(null); 
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [res, admin] = await Promise.all([getAllArticles(), GetAdmin()]);
        if (res.status === 200) {
          const sortedData = [...res.data].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          );
          setData(sortedData);
        }
        setAdminData(admin);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [refresh]);

  // تابع برای لغو ویرایش
  const handleCancelEdit = () => {
    setEditData(null);
    setIsEditing(false);
  };

  if (loading) return <Loading />;
  if (!adminData) return null;
  if (adminData.role !== "manager" && adminData.role !== "postMaker") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full flex justify-center flex-col items-center">
      <Header adminName={adminData.name} />

      <div className="flex flex-col md:flex-row gap-6 justify-between w-full">
        <div className="w-full md:w-1/4 mb-6 lg:mb-0">
          <Navigation />
        </div>

        <div className="w-full md:w-3/4">
          {/* فرم اضافه کردن مقاله */}
          <div
            id="article-form"
            className="w-full flex col-span-4 flex-col gap-4 shadow-lg bg-white rounded-lg p-4"
          >
            <h2 className="text-lg font-semibold text-gray-800">
              {isEditing ? "ویرایش مقاله" : "ایجاد مقاله جدید"}
            </h2>
            <AddArticleForm
              setRefresh={setRefresh}
              setLoading={setLoading}
              editData={editData}
              onCancelEdit={handleCancelEdit}
            />
          </div>

          {/* جدول مقالات */}
          {data && data.length > 0 ? (
            <ArticleTable
              data={data}
              setRefresh={setRefresh}
              setLoading={setLoading}
              setEditData={setEditData}
              setIsEditing={setIsEditing}
            />
          ) : (
            <div className="bg-white rounded-lg shadow-lg p-8 mt-4 text-center">
              <p className="text-gray-500">هیچ مقاله‌ای یافت نشد</p>
              <p className="text-gray-400 text-sm mt-2">
                اولین مقاله خود را با فرم بالا ایجاد کنید
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticlePage;
